export const parseError = (errors?: { file?: string }): string | false => {
  if (!errors) {
    return false
  }

  if (errors.file) {
    return errors.file
  }

  return 'Something went wrong'
}
